export const localStorageEnums = {
  TOKEN: 'token',
  USERDATA: 'userData',
  EMAIL: 'email',
  PASSWORD: 'password',
  USERID: 'userId',
  REMEMBER: 'remember',
};
